import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster, toast } from 'sonner'
import './index.css'
import App from './App.tsx'

// Click-to-dismiss toasts
document.addEventListener('click', (e) => {
  const target = e.target as HTMLElement
  if (target.closest('[data-sonner-toast]')) {
    toast.dismiss()
  }
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        position="top-center"
        toastOptions={{
          classNames: {
            toast: 'bg-card border-border text-foreground cursor-pointer active:scale-95 transition-transform',
            error: '!bg-destructive !text-white !border-destructive',
            title: 'text-inherit',
            description: 'text-inherit opacity-80',
          },
        }}
      />
    </QueryClientProvider>
  </StrictMode>
)
